import React, {useContext, useEffect, useState} from "react"
import {AppDataContext} from "../../App";
import {Box, CircularProgress, Typography} from "@mui/material";
import LoginView from "./login";
import MainView from "./main";
import {getAuth} from "firebase/auth";
import {getRemoteConfig, fetchAndActivate, getString} from "firebase/remote-config"
import UseApiManager from "../manager/api";
import _ from "lodash";
import PropTypes from "prop-types";
import {TabMode} from "./leftTab"
import DocsView from "./docs"

const styles = {
    initializingRoot: {
        display: "flex",
        width: "100vw",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
    },
    initializingBox: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        justifyContent: 'center',
        alignItems: 'center',
    }
}

const IndexView = ({app}) => {

    const { state, setUser, setApiEndpoint, setEnv, setColumnDefs } = useContext(AppDataContext)
    const [fbUser, setFbUser] = useState(undefined)
    const [initialized, setInitialized] = useState(false)
    const { GetFirst, Get } = UseApiManager()

    useEffect(() => {
        if (!app) { return }
        console.log()
        getAuth().onAuthStateChanged(setFbUser)

        setApiEndpoint(process.env.REACT_APP_API_ENDPOINT)
        const remoteConfig = getRemoteConfig()
        fetchAndActivate(remoteConfig)
            .then(() => {})
    }, [app])

    useEffect(() => {
        if (fbUser === undefined || !state.apiEndpoint) { return }

        setInitialized(false)

        if (!fbUser) {
            setUser(null)
            setTimeout(() => setInitialized(true), 100)
            return
        }

        GetFirst("auth/user")
            .then(setUser)
            .catch(e => {
                console.log(e)
            })

        GetFirst("system/env")
            .then(setEnv)
            .catch(e => {
                console.log(e)
            })

        Get("system/column_def")
            .then(setColumnDefs)
            .catch(e => {
                console.log(e)
            })

    }, [fbUser, state.apiEndpoint])

    useEffect(() => {
        setInitialized(prev => {
            if (prev) { return prev }
            return !_.isEmpty(state.user) && !_.isEmpty(state.env) && !_.isEmpty(state.columnDefs)
        })
    }, [state.user, state.env, state.columnDefs])

    return (
        <>
            {!initialized && (
                <Box style={styles.initializingRoot}>
                    <Box style={styles.initializingBox}>
                        <CircularProgress />
                        <Typography>ロード中...</Typography>
                    </Box>
                </Box>
            )}
            {initialized && !state.user && <LoginView />}
            {initialized && state.user && state.tabMode === TabMode.Main && <MainView />}
            {initialized && state.user && state.tabMode === TabMode.Docs && <DocsView />}
        </>
    )


}

IndexView.propTypes = {
    app: PropTypes.any,
}

export default IndexView
